module.exports = __webpack_public_path__ + "static/media/market-img1.d3674592.png";